import React from 'react';
import "../css/Projects.scss";
import ProjectCard from './ProjectCard';
import { motion } from "framer-motion";
import newsimg from "../Images/newsAppImage.png";
import artechimg from "../Images/artechLogo.png";
import nightOwl from "../Images/nightOwl.png";
const Projects = () => {
  return (
    <>
    <div className='project-section'>
      <h2>Projects</h2>
      <div className="projectBody">
        <ProjectCard projectImg={newsimg} appTitle={"News App"} appDesc={"Created a Live News app by using React with the help of News api it fetch all the news from server and added different categories of news like news related to sports ,bussiness, bollywood, technology and many more. It is developed on ( SPA ) technique for zero reloading of web page while scrolling or navigating from one section to another."} />
        <ProjectCard projectImg={artechimg}  appTitle={"Artech Studio"} appDesc={"This is an architectural website created with plain html css and javascript for frontend and used php as a backend language for putting the clients data and created a minimalistic login and signup forms for user to login into this website and it is a multi page website."} />
        <ProjectCard projectImg={nightOwl} appTitle={"N. O. P."} appDesc={"The website u are currently seeing is a portfolio website designed using react framework and currently at developement stage . In this website the concept of component reusability of react framework is achieved . As u r seeing the pretty animations in this website are done by a library Framer Motion and its a completely responsive website."}/>
      </div>
    </div>
    <hr className="style-one"></hr>
    </>
  )
}

export default Projects